import React, {useState, Component} from 'react';
import * as firebase from 'firebase'
import { Redirect, Route } from 'react-router'
import NotificationAlert from 'react-notification-alert';
import Header from './Header.js';
import Footer from './Footer.js';

const serverValue = firebase.database.ServerValue;

let mobileExistNotification

export default class ValidateMobileNumber extends Component {
    // const [weightText, setWeightText] = useState("")
 constructor(props){
     super(props);
     this.state={
        mobileNumber: '',
        usersData: [],
      loading: false,
      redirect: false

     }
 }  

 


  onChangeMobileNumber = event => {
    let mobileNumber
 
    mobileNumber = event.target.value
 
    if(mobileNumber.includes("a")||(mobileNumber.includes("A"))
    ||mobileNumber.includes("b")||(mobileNumber.includes("B"))
    ||mobileNumber.includes("c")||(mobileNumber.includes("C"))
    ||mobileNumber.includes("d")||(mobileNumber.includes("D"))
    ||mobileNumber.includes("e")||(mobileNumber.includes("E"))
    ||mobileNumber.includes("f")||(mobileNumber.includes("F"))
    ||mobileNumber.includes("g")||(mobileNumber.includes("G"))
    ||mobileNumber.includes("h")||(mobileNumber.includes("H"))
    ||mobileNumber.includes("i")||(mobileNumber.includes("I"))
    ||mobileNumber.includes("j")||(mobileNumber.includes("J"))
    ||mobileNumber.includes("k")||(mobileNumber.includes("K"))
    ||mobileNumber.includes("l")||(mobileNumber.includes("L"))
    ||mobileNumber.includes("m")||(mobileNumber.includes("M"))
    ||mobileNumber.includes("n")||(mobileNumber.includes("N"))
    ||mobileNumber.includes("o")||(mobileNumber.includes("O"))
    ||mobileNumber.includes("p")||(mobileNumber.includes("P"))
    ||mobileNumber.includes("q")||(mobileNumber.includes("Q"))
    ||mobileNumber.includes("r")||(mobileNumber.includes("R"))
    ||mobileNumber.includes("s")||(mobileNumber.includes("S"))
    ||mobileNumber.includes("t")||(mobileNumber.includes("T"))
    ||mobileNumber.includes("u")||(mobileNumber.includes("U"))
    ||mobileNumber.includes("v")||(mobileNumber.includes("V"))
    ||mobileNumber.includes("w")||(mobileNumber.includes("W"))
    ||mobileNumber.includes("x")||(mobileNumber.includes("X"))
    ||mobileNumber.includes("y")||(mobileNumber.includes("Y"))
    ||mobileNumber.includes("z")||(mobileNumber.includes("Z"))
    ||mobileNumber.includes("@")||(mobileNumber.includes("$"))
    ||mobileNumber.includes("!")||(mobileNumber.includes("&"))
    ||mobileNumber.includes("^")||(mobileNumber.includes("+"))
    ||mobileNumber.includes("-")||(mobileNumber.includes("_"))
    ||mobileNumber.includes("?")||(mobileNumber.includes("."))
    ||mobileNumber.includes(",")||(mobileNumber.includes("'"))
    ||mobileNumber.includes(";")||(mobileNumber.includes(":"))
    ||mobileNumber.includes("(")||(mobileNumber.includes(")"))
    ||mobileNumber.includes("{")||(mobileNumber.includes("}"))
    ||mobileNumber.includes("[")||(mobileNumber.includes("]"))
    ||mobileNumber.includes("/")||(mobileNumber.includes("="))
    ||mobileNumber.includes("|")||mobileNumber.includes("~")===true){
     this.setState({mobileNumber: mobileNumber.substr(0, mobileNumber.length-1) })
     
    }
    else if(mobileNumber.includes(" ")===true){
 try{
   this.setState({mobileNumber: mobileNumber.substr(0, mobileNumber.length-1) })
 
 }
 catch{
   
 }
    }
    else{
     this.setState({ mobileNumber: event.target.value });
    }
 
 
   };

     

     componentDidMount(){
       localStorage.clear()
//this.loadSellersData()
    }










proceedClick(){
 
 
  this.setState({loading: true})
         const dbRefObject = firebase.database().ref().child('users');
           dbRefObject.once('value', snapshot => {
             // convert messages list from snapshot
             const usersObject = snapshot.val();
       
             if (usersObject) {
               const usersList = Object.keys(usersObject).map(key => ({
                 ...usersObject[key],
                 uid: key,
               }));
              // var user = firebase.auth().currentUser;
       
       this.setState({ loading: false})
       let mobileExist  = false
       for(let i=0; i<usersList.length; i++){
      
        if(usersList[i].mobileNumber===this.state.mobileNumber){
          mobileExist = true
          // console.log('true')
          // console.log(usersList)
//mobileExist = true
           //this.setState({name: this.state.sellersData[i].name, gender: this.state.sellersData[i].gender, address:this.state.sellersData[i].address})
        }
        
          } 
      //  console.log(mobileExist)

      if(mobileExist===false){
          localStorage.setItem('mobileNumber', this.state.mobileNumber)
this.setState({redirect: true})
      }

     else if(mobileExist===true){
        this.setState({redirect: false})
        mobileExistNotification =
    {
      place: 'tl',
      message: (
        <div>
          <div>
            Mobile number already registered
          </div>
        </div>
      ),
      type: "warning",
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 5
    }

    this.refs.notify.notificationAlert(mobileExistNotification);


      }
             
             } else {
             // console.log('nothing')

                this.setState({loading: false})

              //  this.setState({name: '', gender: 'male', address: '', loader: false})

               // this.setState({ users: null, });
             }
           });
    }
  
   

 

    handleInputTextChange=(text)=>{
        
        if(/^\d+$/.test(text) || text===''){
           
            this.setState({mobileNumber: text})
  for(let i=0; i<this.state.sellersData.length; i++){
if(this.state.sellersData[i].mobileNumber===text){

   
   this.setState({name: this.state.sellersData[i].name, gender: this.state.sellersData[i].gender, address:this.state.sellersData[i].address})
}
else{
  //  this.setState({name: '', gender: 'male', address:'', loader: false})

}
  }          

           
            
        }
    }

render(){

   
    
    return (
      <>
       <NotificationAlert ref="notify" />
      <Header/>
        <div class="container" style={{maxWidth: 700, marginTop: 200, marginBottom: 280}}>
        <marquee style={{color: 'green'}} scrolldelay="200">Over 745,000 Nigeria Youths have benefited from Nigeria Youths Empowerers NGO.</marquee>
      
        <form>
        <div class="input-group mb-3 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Mobile Number</span>
          </div>
          <input type="text" class="form-control" placeholder="Enter Mobile Number" name="mobileNumber" value={this.state.mobileNumber}
                                  onChange={this.onChangeMobileNumber} maxLength="11"/>
        </div>
        <br/>
      
        <button disabled={this.state.mobileNumber.length<11} onClick={() => this.proceedClick()} type="button" class="btn btn-success btn-block" >
        <span hidden={this.state.loading===true}>Proceed</span>
                         <div hidden={this.state.loading===false} style={{marginBottom:'-5px', marginTop: '-5px'}} class="spinner-border text-light"></div>
                          
        </button>
       
      </form>
      
      
      </div>
      <Footer/>
      {this.state.redirect === true && (
          <Redirect to={'/application-form'} />
        )}
      </>
    )
}}


